"use client";
import {gsap, ScrollTrigger} from '@/lib/gsap';
import {handleScrollToElement} from "@/lib/utils";
/**
 * Client component for initializing global clientside scripts
 *
 * TODO:
 *  - Continuous Scrolling: https://codepen.io/GreenSock/pen/XWzRraJ
 */
import {useEffect} from 'react';

interface ClientWrapperProps {
    children: React.ReactNode;
}

const useSnap = false;

export default function ClientBodyWrapper({children}: ClientWrapperProps) {


    useEffect(() => {
        // Load GSAP or initialize animations

        // ## Bind Elements
        const header = document.querySelector('header');
        const headerOffset = header?.offsetHeight || 96;
        const navLinks: HTMLElement[] = gsap.utils.toArray('nav ul li span, nav ul li a');


        console.log('navLinks', navLinks)


        const removeActiveClasses = () => {
            // console.log('removeActiveClasses');
            navLinks.forEach(link => link.classList.remove('active'));
        };

        function setLinkActive(link: HTMLElement) {
            // console.log('setLinkActive', link);
            removeActiveClasses();
            link.classList.add("active");
        }

        // Handle initial URL hash (e.g., #events?r=abc)
        const handleInitialHash = () => {
            const hash = window.location.hash; // e.g., #events?r=abc
            if (hash) {
                // Extract hash without query string (e.g., #events)
                const hashId = hash.split('?')[0].replace('#', ''); // e.g., events
                console.log('[ClientBodyWrapper] Initial hash:', hashId);
                const targetElement = document.getElementById(hashId);
                if (targetElement) {
                    // Delay scroll to allow splash screen and navbar animations to complete
                    setTimeout(() => {
                        console.log('[ClientBodyWrapper] Scrolling to initial hash:', hashId);
                        handleScrollToElement(targetElement);
                    }, 2000); // TODO: Adjust delay based on splash screen duration (500ms) + navbar (300ms)
                    // TODO-CONT: it's better to execute the scroll-to after all of the other animations finish loading
                } else {
                    console.warn('[ClientBodyWrapper] Target element not found for hash:', hashId);
                }
            }
        };

        // Scroll on end
        handleInitialHash();

        // TODO: set hash as person navigates through the page

        navLinks.forEach(a => {
            const slug = a.dataset['slug'];
            // console.log('binding scrollHandler', slug, a);
            const targetElement = document.querySelector(`#${slug}`);


            ScrollTrigger.create({
                trigger: targetElement,
                start: `top+=${headerOffset} center`,
                // or "top top+=headerOffset"
                end: "bottom bottom",

                // TODO: adjust toggle boundaries given full screen height
                onToggle: (self) => {
                    if (self.isActive) {
                        setLinkActive(a);
                        // Update URL hash without adding to history
                        if (slug) {
                            const currentSearch = window.location.search; // Preserve query string (e.g., ?r=abc)
                            window.history.replaceState(null, '', `${currentSearch}#${slug}`);
                            console.log('[ClientBodyWrapper] Updated URL hash:', `${currentSearch}#${slug}`);
                        }
                    } else {
                        removeActiveClasses();
                        // Optionally clear hash when no section is active
                        // window.history.replaceState(null, '', window.location.pathname + window.location.search);
                    }
                },
            });

            a.addEventListener("click", function (e) {
                e.preventDefault();
                if (targetElement) {
                    handleScrollToElement(targetElement);
                }

            });
        });

        if (useSnap) {
            // ## Bind Full Screen Sections (snapping)
            const sections: HTMLElement[] = gsap.utils.toArray('.full-screen-section');
            sections.forEach((section: HTMLElement, index) => {
                const sectionId = section.getAttribute('id');

                // Set initial z-index for each section (ascending order from top to bottom)
                sections.forEach((section, index) => {
                    gsap.set(section, {zIndex: index + 1});
                });

                const navLink = document.querySelector(`nav ul li [data-slug="${sectionId}"]`);

                console.log('configuring', section, navLink)

                ScrollTrigger.create({
                    trigger: section,
                    scrub: true,
                    pin: true,
                    // start: "top top",
                    start: "top +=104",

                    end: "+=100%",
                    // end: "+=100vh", // Use viewport height for consistency
                    // end: "+=100",
                    toggleActions: "play none none none", // Play immediately if already in view

                    markers: false,
                    onEnter: () => {
                        // Increase z-index of the current section to be higher than all previous sections
                        gsap.to(section, {
                            zIndex: sections.length + 1, // Ensure it's on top
                            duration: 0.3,
                            ease: "power1.inOut"
                        });
                    },
                    onEnterBack: () => {
                        // Restore z-index when scrolling back up
                        gsap.to(section, {
                            zIndex: sections.length + 1,
                            duration: 0.3,
                            ease: "power1.inOut"
                        });
                    },
                    onLeave: () => {
                        // Optionally reduce z-index when leaving (if needed)
                        gsap.to(section, {
                            zIndex: index + 1,
                            duration: 0.3,
                            ease: "power1.inOut"
                        });
                    },
                    onLeaveBack: () => {
                        // Restore original z-index when scrolling back past the section
                        gsap.to(section, {
                            zIndex: index + 1,
                            duration: 0.3,
                            ease: "power1.inOut"
                        });
                    }
                });
            });
        }

        ScrollTrigger.refresh();

        // Cleanup
        return () => {

            // Stop animations if needed
            ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
            navLinks.forEach(a => {
                a.removeEventListener('click', () => {
                });
            });
        };
    }, []); // Empty deps: runs once on mount


    return <>{children}</>;
}
